import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (sessionIdMatch) {
          const sessionId = sessionIdMatch[1];
          
          // Exchange session_id for session_token
          const userData = await login(sessionId);
          
          if (userData) {
            // Clear the hash and navigate to dashboard
            window.history.replaceState(null, '', '/admin/dashboard');
            navigate('/admin/dashboard', { state: { user: userData }, replace: true });
          } else {
            throw new Error('Login failed');
          }
        } else {
          throw new Error('No session_id found');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/admin/login', { replace: true });
      }
    };

    processAuth();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#5cc8e8] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
}
